import { render, staticRenderFns } from "./card-compare-b1.vue?vue&type=template&id=6e115423&scoped=true&"
import script from "./card-compare-b1.vue?vue&type=script&lang=js&"
export * from "./card-compare-b1.vue?vue&type=script&lang=js&"
import style0 from "./card-compare-b1.vue?vue&type=style&index=0&id=6e115423&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e115423",
  null
  
)

export default component.exports